import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';

interface AdComponentProps {
  adSlot: string;
  adFormat?: string;
}

declare global {
  interface Window {
    adsbygoogle: { push: (config: object) => void }[];
  }
}

const enableAds = process.env.REACT_APP_ENABLE_ADS.toLowerCase() === "true";

const AdComponent: React.FC<AdComponentProps> = ({ adSlot }) => {
  useEffect(() => {
    if (enableAds) {
      let retries = 0;
      const maxRetries = 50;
      let timeoutId: NodeJS.Timeout;

      const attemptPush = () => {
        if (window.adsbygoogle) {
          try {
            window.adsbygoogle.push({} as any);
          } catch (e) {
            console.error('AdSense push error:', e);
          }
        } else if (retries < maxRetries) {
          retries++;
          timeoutId = setTimeout(attemptPush, 100);
        } else {
          console.warn('AdSense library failed to load after max retries');
        }
      };

      attemptPush();

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, []);

  // skip component if ads are disabled
  if (!enableAds) {
    return <></>
  }

  return (
    <Box
      sx={{
        width: '100%',
        my: 2,
        boxShadow: { xs: 'none', md: '0 1px 4px rgba(0, 0, 0, 0.1)' },
        borderRadius: { xs: 0, md: 3 },
        overflow: 'hidden',
        bgcolor: 'background.paper',
        p: 1,
        scrollSnapAlign: 'start',
        scrollSnapStop: 'always',
        minHeight: '100%',
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
        Ad goes here
      </Typography>

      <ins
        className='adsbygoogle'
        style={{ display: 'block', width: '100%' }}
        data-ad-client={process.env.REACT_APP_ADSENSE_PUB_ID}
        data-ad-slot={process.env.REACT_APP_ADSENSE_SLOT_ID_M}
        data-ad-format='fluid'
        data-ad-layout-key={process.env.REACT_APP_ADSENSE_LAYOUT_KEY}
        data-full-width-responsive='true'
        data-ad-test={process.env.REACT_APP_ADSENSE_TEST_MODE}
        // data-ad-test={process.env.NODE_ENV === 'development' ? 'on' : undefined}
      ></ins>
    </Box>
  );
};

export default React.memo(AdComponent);
